export const $DEBOUNCE_DELAY: number = 1000;
export const $DESKTOP_DEVICE_TYPE = 'desktop';
export const $TABLET_DEVICE_TYPE = 'tablet';
export const $MOBILE_DEVICE_TYPE = 'mobile';
export const $HOME_PAGE_TYPE: string = 'home';
export const $PRODUCT_PAGE_TYPE: string = 'product';
export const $CATEGORY_PAGE_TYPE: string = 'category';
export const $SEARCH_PAGE_TYPE: string = 'search';
export const $CART_PAGE_TYPE: string = 'cart';
export const $CHECKOUT_PAGE_TYPE: string = 'checkout';
export const $THANK_YOU_PAGE_TYPE: string = 'thankyou';
export const $FAILURE_PAGE_TYPE: string = 'failure';
export const $PAGE_TYPE_KEY: string = 'page_type';
export const $HIDDEN_CLASS_NAME = 'hidden';
export const $ANIMATION_SPIN_CLASS_NAME: string = 'animate-spin';
export const $LOADER_CLASS_NAME = 'loader';
export const $FLEX_CLASS_NAME = 'flex';
export const $ACTIVE_CLASS_NAME = 'active';
export const $_ERROR_CLASS_NAME = '_error';
export const $_WAS_VALIDATED_CLASS_NAME: string = '_was-validated';
export const $LAZY_LOAD_CLASS_NAME: string = 'lazy-load';
export const $GRID_COLS_1_CLASS_NAME: string = 'grid-cols-1';
export const $GRID_COLS_2_CLASS_NAME: string = 'grid-cols-2';
